// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const NavLeftArrow = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M.842 6.044a.97.97 0 0 1 .307-.731L5.593.869a1.06 1.06 0 0 1 .335-.232.888.888 0 0 1 .362-.082c.292 0 .526.09.704.273a.889.889 0 0 1 .274.663.89.89 0 0 1-.09.404 1.115 1.115 0 0 1-.218.307L5.429 3.74 3.166 5.818l-.424-.622 2.66-.143h7.724c.31 0 .558.09.745.273.187.182.28.422.28.718s-.093.535-.28.718c-.187.182-.435.273-.745.273H5.401l-2.659-.143.424-.622 2.263 2.078 1.531 1.53c.091.092.164.197.219.315.059.114.089.247.089.397a.888.888 0 0 1-.274.663c-.178.182-.412.273-.704.273-.25 0-.48-.102-.69-.307L1.15 6.775a.985.985 0 0 1-.308-.731Z"
			fill="#fff"
			fillOpacity={0.4}
		/>
	</svg>
);
export default NavLeftArrow;
